<template>
	<div class="table-responsive">
        <table class="table table-border">
            <thead>
                <tr>
                    <th scope="col">Statement of Expenses</th>
                    <th scope="col">B/L {{year-1}}</th>
                    <th v-bind:class="{'active-month': currentMonth == 1}"  scope="col">Jan</th>
                    <th v-bind:class="{'active-month': currentMonth == 2}"  scope="col">Feb</th>
                    <th v-bind:class="{'active-month': currentMonth == 3}"  scope="col">Mar</th>
                    <th v-bind:class="{'active-month': currentMonth == 4}"  scope="col">Apr</th>
                    <th v-bind:class="{'active-month': currentMonth == 5}"  scope="col">May</th>
                    <th v-bind:class="{'active-month': currentMonth == 6}"  scope="col">Jun</th>
                    <th v-bind:class="{'active-month': currentMonth == 7}"  scope="col">Jul</th>
                    <th v-bind:class="{'active-month': currentMonth == 8}"  scope="col">Aug</th>
                    <th v-bind:class="{'active-month': currentMonth == 9}"  scope="col">Sep</th>
                    <th v-bind:class="{'active-month': currentMonth == 10}" scope="col">Oct</th>
                    <th v-bind:class="{'active-month': currentMonth == 11}" scope="col">Nov</th>
                    <th v-bind:class="{'active-month': currentMonth == 12}" scope="col">Dec</th>
                    <th scope="col">Total</th>
                </tr>
            </thead>
			<tbody>
                <tr v-for="expenseFee, key, index in getExpenses">
                    <td scope="row"> <strong> {{ expenseFee.expenseName }}</strong></td>
                    <td v-bind:class="{'active-month-column': currentMonth == (key2 )}" v-for="fee, key2 in expenseFee.fees">
                        <div v-if="key2 < 12">                            
                            <div v-if="fee == 0">
                                -
                            </div>
                            <div v-else>
                                {{ $filters.toCurrency(fee) }}
                            </div>
                        </div>
                        <div v-else>
                        <strong>  
                            <div v-if="fee == 0">
                                -
                            </div>
                            <div v-else>
                                {{ $filters.toCurrency(fee) }}
                            </div> </strong>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>
                        <strong>Total</strong>
                    </td>
                    <td v-bind:class="{'active-month-column': currentMonth == (key3 )}" v-for="(total,key3) in totalFees"> 
                        <strong> 
                            <div v-if="total == 0">
                                -
                            </div>
                            <div v-else>
                                {{ $filters.toCurrency(total) }}
                            </div> 
                        </strong>
                    </td>
                </tr>
            </tbody>
        </table>		
	</div>
</template>

<script>
import { mapState } from "vuex";
    export default {
		props : ['route','period','filter',"owner", "unitId"],
        data: function () {
  return {
	expenseFees : [], 
	totalFees : [],
	index : 0,
	isModalVisible: true,
	expenseTypeId: 0,
    monthParam: 0,
    year: 0
  }
},
 watch: {
    value(val) {
      this.$emit("update:propertyId", val);

    },
    value2(val) {
      this.$emit("update:unitId", val);

    },
    propertyId(val) {
      this.value = val;
      this.fetchStatement();
    },
    unitId(val){
        this.value2 = val;
        this.fetchStatement();
    }
  },
                    
        mounted() {
            this.fetchStatement();
            //this.propertyHistory = JSON.parse(this.propertyAttribute)
            
            //console.log(this.propertyAttribute)
            //this.propertyHistory = this.propertyAttribute
        
        if (!this.$period.isCurrent(this.period)) {
                this.currentMonth = 12;
                this.year = new Date().getFullYear()-(Number(this.period) - 1);
                    }
            else{
                    this.year = new Date().getFullYear();
                this.currentMonth = new Date().getMonth() + 1;
            }
            
           // this.fetchStatement();
            //this.propertyHistory = JSON.parse(this.propertyAttribute)

            //console.log(this.propertyAttribute)
            //this.propertyHistory = this.propertyAttribute
        },
        
        methods: {
            beforeOpen (event) {
                this.expenseTypeId = event.params.expensetypeid;
                this.monthParam = event.params.month + 1;
    },
                        showModal() {
        this.isModalVisible = true;
        alert(this.isModalVisible)
        },
        closeModal() {
        this.isModalVisible = false;
        },
                    fetchStatement: function(){
                            var request = '/statement/propertyexpenses';
               // if(this.route=="home")
                 //   request = '/home/statment/get/';
                        request = request + "?id=" + (this.owner ? this.propertyId : this.unitId) + "&period=" + this.period;
              /*  if(this.period == 2)	
                    request = request +'/'+this.period;
                else
                    request = request +'?id='+this.buildingId;*/
                  
                    this.$http.get(request, {
                        id : (this.owner ? this.propertyId : this.unitId)
                    }).then(({data}) => {
                                this.mute = false;
                                //this.contacts = data.contacts;
                           this.mute = false;
                    // let myObjStr = JSON.stringify(data.expenseFees);
                    this.expenseFees = data.expensefees;
                    this.totalFees = data.totalFees;

                });
                    

                    },
					

            /**
             * Prepare the component.
             */
            
            },
			
			computed : {
                ...mapState({
      building: (state) => state.building.currentBuilding,
      property:(state)=>state.property.currentProperty,
      buildings: (state) => state.building.buildings,
      numberOfAllowedBuildings: (state) =>
        state.building.numberOfAllowedBuildings,
    }),
    buildingName(){
      if(this.property != null && this.property!= undefined && this.owner)
        return  this.property.buildingName;
    if(this.building != null && this.building!= undefined)
    return  this.building.name;
      return ""
    },
    buildingId(){
        if(this.property != null && this.property!= undefined && this.owner)
        return  this.property.buildingId;
        if(this.building != null && this.building!= undefined)
    return  this.building.id;
      return ""
    },
    propertyId(){
      if(this.property != null)
        return  this.property.id;
      return ""
    },
    propertyName(){
      if(this.property != null)
        return  this.property.propertyName;
      return ""
    },
				getExpenses() {
      
                   
                    return  this.expenseFees;
                    
                    },
			total: function(){
                console.log(this.expenseFees);
                return this.expenseFees[0].reduce(function(total, fees){

                    return total + fees[0]; 
                },0);
        },
			}

	}                // Our Javascript logic
    
    
</script>
